import type { TrackerProvider, TrackEvent } from '../types';

export const gtmProvider: TrackerProvider = {
  name: 'gtm',
  track: (event: TrackEvent) => {
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: event.event,
      eventAction: event.eventAction,
      eventCategory: event.eventCategory,
      eventDescription: event.eventDescription,
      eventLabel: event.eventLabel,
      screenName: event.screenName,
      ...event.payload,
    });
  },
  setUser: userId => {
    if (!window.dataLayer) return;
    window.dataLayer.push({ event: 'setUserId', userId: userId ?? '' });
  },
  screen: (screenName, payload) => {
    if (!window.dataLayer) return;
    window.dataLayer.push({ event: 'screen_view', screenName, ...payload });
  },
};
